module.exports = __webpack_public_path__ + "img/it.40e2bbf7.png";